const variants = {
  success:  'bg-brand-100 text-brand-700 dark:bg-brand-900/40 dark:text-brand-300 ring-brand-200 dark:ring-brand-800',
  warning:  'bg-accent-100 text-accent-800 dark:bg-accent-900/40 dark:text-accent-200 ring-accent-200 dark:ring-accent-800',
  danger:   'bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-300 ring-rose-200 dark:ring-rose-800',
  info:     'bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-300 ring-sky-200 dark:ring-sky-800',
  neutral:  'bg-ink-100 text-ink-700 dark:bg-ink-800 dark:text-ink-300 ring-ink-200 dark:ring-ink-700',
};

const Badge = ({ variant = 'neutral', children, dot = false, className = '' }) => (
  <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ring-1 ring-inset ${variants[variant]} ${className}`}>
    {dot && <span className="w-1.5 h-1.5 rounded-full bg-current animate-pulse-dot" />}
    {children}
  </span>
);

export default Badge;
